import { axios } from "@/utils/request";

// 2030102 获取报告详情
export function getTongueCaseVo(data) {
  return axios({
    url: '/shopCustomer/getTongueCaseVo',
    method: 'post',
    data
  })
}

// 1030103 获取报告商品详情
export function getCaseGoodsVo(data) {
  return axios({
    url: '/shopCustomer/getCaseGoodsVo',
    method: 'post',
    data
  })
}
